import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const RanchDetailForm = (props) => {
  const { addForm } = props;

  const [unitList, setUnitList] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [existingRanches, setExistingRanches] = useState([]);

  const { sendRequest: getRanches } = useHttp();
  const { sendRequest: getUnits } = useHttp();
  const { sendRequest: getRegions } = useHttp();
  const { sendRequest: postRanchData } = useHttp();

  const [formData, setFormData] = useState({
    regionId: "",
    ranchName: "",
    totalArea: "",
    ranchUnitId: "",
    ranchCode: "",
    areaPerPlot: "",
    irrigationSource: "",
  });

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getRanches(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) setExistingRanches(res);
      }
    );

    getUnits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          const filterAreaUnits =
            res &&
            res.filter(
              (itm) => itm.unitTypeName === "Area" || itm.unitTypeName === "Ha"
            );
          setUnitList(filterAreaUnits);
        }
      }
    );

    getRegions(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => res && setRegionData(res)
    );
  }, [getUnits, getRegions, getRanches]);

  // const handleApply = () => {
  //   const {
  //     ranchCode,
  //     totalArea,
  //     ranchUnitId,
  //     // areaPerPlot,
  //     regionId,
  //     ranchName,
  //     // irrigationSource,
  //   } = formData;

  //   if (
  //     !ranchCode ||
  //     !totalArea ||
  //     !ranchUnitId ||
  //     // !areaPerPlot ||
  //     !regionId ||
  //     !ranchName
  //     // !irrigationSource
  //   ) {
  //     toast.error("Please fill all Ranch Details.");
  //     return;
  //   }

  //   const isDuplicateName = existingRanches.some(
  //     (item) =>
  //       item.ranchName?.toLowerCase().trim() === ranchName.toLowerCase().trim()
  //   );

  //   const isDuplicateCode = existingRanches.some(
  //     (item) =>
  //       item.ranchCode?.toLowerCase().trim() === ranchCode.toLowerCase().trim()
  //   );

  //   if (isDuplicateName) {
  //     toast.error("Ranch Name already exists. Please choose another.");
  //     return;
  //   }

  //   if (isDuplicateCode) {
  //     toast.error("Ranch Code already exists. Please choose another.");
  //     return;
  //   }

  //   const total = parseFloat(totalArea);
  //   const perPlot = parseFloat(areaPerPlot);

  //   const decimalPlaces = (num) => {
  //     const str = num.toString();
  //     const decimalPart = str.split(".")[1];
  //     return decimalPart ? decimalPart.length : 0;
  //   };

  //   if (decimalPlaces(perPlot) > 2) {
  //     toast.error("Area per plot should not have more than 2 decimal places.");
  //     return;
  //   }

  //   if (perPlot > total) {
  //     toast.error("Area per plot cannot be greater than total area.");
  //     return;
  //   }

  //   const unit = parseInt(ranchUnitId);
  //   const fullPlotCount = Math.floor(total / perPlot);
  //   const remainder = total % perPlot;

  //   const plots = [];

  //   for (let i = 1; i <= fullPlotCount; i++) {
  //     plots.push({
  //       plotCode: `${ranchCode} ${i.toString().padStart(3, "0")}`,
  //       plotArea: perPlot,
  //       unitId: unit,
  //     });
  //   }

  //   if (remainder > 0) {
  //     plots.push({
  //       plotCode: `${ranchCode} ${(plots.length + 1)
  //         .toString()
  //         .padStart(3, "0")}`,
  //       plotArea: parseFloat(remainder.toFixed(2)),
  //       unitId: unit,
  //     });
  //   }

  //   setTableData(plots);
  // };

  const handleApply = () => {
    const { ranchCode, totalArea, ranchUnitId, regionId } = formData;

    if (!ranchCode || !totalArea || !ranchUnitId || !regionId) {
      toast.error("Please fill all Ranch Details.");
      return;
    }

    const isDuplicateCode = existingRanches.some(
      (item) =>
        item.ranchCode?.toLowerCase().trim() === ranchCode.toLowerCase().trim()
    );

    if (isDuplicateCode) {
      toast.error("Ranch Code already exists. Please choose another.");
      return;
    }

    // ✅ Just add a single blank row instead of auto-calculation
    setTableData([
      {
        plotCode: "",
        plotArea: "",
        unitId: parseInt(ranchUnitId),
      },
    ]);
  };

  const handleDeleteRow = (e, index) => {
    e.preventDefault();
    const updated = [...tableData];
    updated.splice(index, 1);
    setTableData(updated);
  };

  const handleSubmitTable = (e) => {
    e.preventDefault();

    // Check for duplicate plotCodes
    const codes = tableData.map((p) => p.plotCode.trim());
    const hasDuplicateCodes = new Set(codes).size !== codes.length;

    if (hasDuplicateCodes) {
      toast.error("Duplicate Plot Codes are not allowed.");
      return;
    }

    const allocatedTotal = tableData.reduce(
      (sum, r) => sum + parseFloat(r.plotArea || 0),
      0
    );

    const totalAreaFloat = parseFloat(formData.totalArea || 0);

    if (allocatedTotal.toFixed(2) > totalAreaFloat.toFixed(2)) {
      toast.error(
        `Total allocated area (${allocatedTotal.toFixed(
          2
        )}) does not match Total Ranch Area (${totalAreaFloat.toFixed(2)}).`
      );
      return;
    }

    const selectedRegion = regionData.find(
      (x) => String(x.regionId) === String(formData.regionId)
    );

    const payload = {
      ranchDetails: {
        // ...formData,
        ranchUnitId: parseInt(formData.ranchUnitId),
        ranchName: selectedRegion ? selectedRegion.regionName : "",
        ranchCode: selectedRegion ? selectedRegion.regionCode : "",
        regionId: selectedRegion ? selectedRegion.regionId : null,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        totalArea: parseFloat(formData.totalArea).toFixed(2),
        serviceId: props.sId, 
      },
    };

    payload.ranchDetails.plots = tableData.map((p) => ({
      plotCode: p.plotCode,
      plotArea: p.plotArea,
      unitId: p.unitId,
    }));

    postRanchData(
      {
        url: "/api/ranchDetail/",
        method: "POST",
        body: payload,
      },
      () => {
        toast.success("Ranch and plots submitted successfully!");
        setFormData({
          regionId: "",
          ranchName: "",
          totalArea: "",
          ranchUnitId: "",
          ranchCode: "",
          areaPerPlot: "",
          irrigationSource: "",
        });
        setTableData([]);
        addForm(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      const ranch = props.update;
      // console.log("ranch",ranch)

      setFormData({
        regionId: ranch.regionId || "",
        ranchName: ranch.ranchName || "",
        totalArea: ranch.totalArea || "",
        ranchUnitId: ranch.ranchUnitId || "",
        ranchCode: ranch.ranchCode || "",
        areaPerPlot: ranch.areaPerPlot || "",
        irrigationSource: ranch.irrigationSource || "",
      });

      const lockedIds = ranch.farmerplots?.map(fp => fp.ranchPlotId) || [];

      // Load plots into tableData
      if (ranch.plots && ranch.plots.length > 0) {
        setTableData(
          ranch.plots.map((p) => ({
            plotCode: p.plotCode,
            plotArea: p.plotArea,
            unitId: p.unitId || ranch.ranchUnitId,
            ranchPlotId: p.ranchPlotId,
            isLocked: lockedIds.includes(p.ranchPlotId),
          }))
        );
      }
    }
  }, [props.update]);

  return (
    <div className="content-wrapper">
      <section className="content">
        <form
          style={{ margin: "10px", paddingTop: "20px" }}
          onSubmit={handleSubmitTable}
        >
          <div className="container-fluid">
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">Ranch Detail</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-md-3">
                    <label>Ranch Name</label>
                    <select
                      className="form-control"
                      value={formData.regionId}
                      onChange={(e) => {
                        const selectedRegion = regionData.find(
                          (x) => String(x.regionId) === String(e.target.value)
                        );
                        setFormData({
                          ...formData,
                          regionId: e.target.value,
                          ranchCode: selectedRegion
                            ? selectedRegion.regionCode
                            : "",
                        });
                      }}
                      required
                      readOnly={props.update}
                    >
                      <option value="">Select...</option>
                      {regionData.map((x) => (
                        <option key={x.regionId} value={x.regionId}>
                          {x.regionName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label>Ranch Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.ranchCode}
                      readOnly
                    />
                  </div>

                  {/* <div className="col-md-3">
                    <label>Ranch Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.ranchName}
                      onChange={(e) =>
                        setFormData({ ...formData, ranchName: e.target.value })
                      }
                      required
                    />
                  </div> */}

                  <div className="col-md-3">
                    <label>Total Area</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.totalArea}
                      onChange={(e) =>
                        setFormData({ ...formData, totalArea: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Unit</label>
                    <select
                      className="form-control"
                      value={formData.ranchUnitId}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          ranchUnitId: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Select...</option>
                      {unitList.map((x) => (
                        <option key={x.unitId} value={x.unitId}>
                          {x.unitName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* <div className="col-md-3 mt-2">
                    <label>Area/Plot</label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.areaPerPlot}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
                          setFormData({
                            ...formData,
                            areaPerPlot: value,
                          });
                        }
                      }}
                      step="0.01"
                    />
                  </div> */}

                  {/* <div className="col-md-3 mt-2">
                    <label>Irrigation Source</label>
                    <select
                      className="form-control"
                      value={formData.irrigationSource}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          irrigationSource: e.target.value,
                        })
                      }
                    >
                      <option value="">Select...</option>
                      <option value="rivers">Rivers</option>
                      <option value="lakes">Lakes</option>
                      <option value="tubeWell">Tube Well</option>
                      <option value="boreWell">Bore Well</option>
                      <option value="dripIrrigation">Drip Irrigation</option>
                    </select>
                  </div> */}

                  <div className="col-md-3 mt-4">
                    <button
                      type="button"
                      className="btn btn-primary mt-2"
                      onClick={handleApply}
                    >
                      Apply
                    </button>
                  </div>
                </div>

                {tableData.length > 0 && (
                  <div className="mt-4">
                    <div
                      className="table-responsive custom-scrollbar"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Field Code</th>
                            <th>Field Area</th>
                            <th>Unit</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((row, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={row.plotCode}
                                  readOnly={row.isLocked}
                                  onChange={(e) => {
                                    const updated = [...tableData];
                                    updated[index].plotCode = e.target.value;
                                    setTableData(updated);
                                  }}
                                  required
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={row.plotArea}
                                  readOnly={row.isLocked}
                                  step="0.01"
                                  onChange={(e) => {
                                    const updated = [...tableData];
                                    updated[index].plotArea = e.target.value;
                                    setTableData(updated);
                                  }}
                                  required
                                />
                              </td>
                              <td>
                                {
                                  unitList.find((u) => u.unitId === row.unitId)
                                    ?.unitName
                                }
                              </td>
                              <td>
                                <button
                                  className="btn"
                                  onClick={(e) => handleDeleteRow(e, index)}
                                  disabled={row.isLocked}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="text-right mt-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() =>
                          setTableData([
                            ...tableData,
                            {
                              plotCode: "",
                              plotArea: "",
                              unitId: parseInt(formData.ranchUnitId),
                            },
                          ])
                        }
                      >
                        <i className="fas fa-plus"></i> Add Row
                      </button>
                    </div>
                    <div className="mt-2 font-weight-bold">
                      Total Area Allocated:
                      {tableData
                        .reduce(
                          (sum, r) => sum + parseFloat(r.plotArea || 0),
                          0
                        )
                        .toFixed(2)}{" "}
                      / {parseFloat(formData.totalArea || 0).toFixed(2)}
                    </div>

                    <div className="text-center mt-2">
                      <button type="submit" className="btn btn-success">
                        Submit Ranch
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
};

export default RanchDetailForm;
